// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var LayersEnum;
(function (LayersEnum) {
    LayersEnum[LayersEnum["Main"] = 0] = "Main";
    LayersEnum[LayersEnum["Quotes"] = 1] = "Quotes";
    LayersEnum[LayersEnum["CrossHair"] = 2] = "CrossHair";
    LayersEnum[LayersEnum["Tools"] = 3] = "Tools";
})(LayersEnum || (LayersEnum = {}));
